import React from 'react'
import intl from 'react-intl-universal'

const OrLine = () => (
  <div className="hr-or m-y-md caps semibold">{intl.get('or')}</div>
)

export default OrLine
